import { render, staticRenderFns } from "./conservationHeroes.vue?vue&type=template&id=6c049ab7&scoped=true&"
import script from "./conservationHeroes.vue?vue&type=script&lang=js&"
export * from "./conservationHeroes.vue?vue&type=script&lang=js&"
import style0 from "./conservationHeroes.vue?vue&type=style&index=0&id=6c049ab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c049ab7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VFlex,VIcon,VImg,VLayout,VSheet,VSnackbar})
